module.exports = __webpack_public_path__ + "static/media/scoot.3ada9f6a.webp";